import React, { useState } from "react";
import { changePassword } from "../../types/authService";
import { useNavigate } from "react-router-dom";
import "../../style/user/ChangePassword.css";

const ChangePassword: React.FC = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userName =  localStorage.getItem('userName') || '';

  const submit = async () => {
    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }

    try {
      setLoading(true);
      await changePassword(userName, oldPassword, newPassword );

      alert("Password changed successfully. Please login again.");
      localStorage.clear();
      navigate("/login");
    } catch (err: any) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <h2>Change Password</h2>

      <div className="form-card">
        <input
          type="password"
          placeholder="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button onClick={submit} disabled={loading}>
          {loading ? "Updating..." : "Change Password"}
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
